/** 시간 포맷 타입 */
const dateFormatType = {
    /** yyyy-MM */
    MONTH: 'yyyy-MM',
    /** yyyy-MM-dd */
    DATE: 'yyyy-MM-dd',
    /** yyyyMMdd */
    DATE_NONE_HYPHEN: 'yyyyMMdd',
    /** yyyy-MM-dd HH:mm */
    FULL_DATE_MINUTE: 'yyyy-MM-dd HH:mm',
    /** yyyy-MM-dd HH:mm:ss */
    FULL_DATE: 'yyyy-MM-dd HH:mm:ss',
    /** HH:mm:ss */
    TIME: 'HH:mm:ss',
    /** HH:mm */
    SHORT_TIME: 'HH:mm',
    /** HH시 mm분 */
    STANDARD_TIME: 'HH시 mm분',
    /** a hh시 mm분 ss초 */
    LOCAL_TIME: 'a hh시 mm분 ss초',
};
export default dateFormatType;
